<template>
  <div>
  <v-autocomplete
    :items="items"
    @change="change"
    :label="label || 'Wybierz zawodnika'"
    cache-items
    item-text="full_name"
    item-value="id"
    :search-input.sync="search"
    v-model="val"
    return-object
    clearable
    :error="error"
    :error-messages="errorMessages"
  >
  </v-autocomplete>
  </div>

</template>
<script>
import {fetchRunners, getRunner} from '@/runners/api'
export default {
  props: {
    value: Number,
    error: Boolean,
    label: String,
    errorMessages: [String, Array]
  },
  data () {
    return {
      items: [],
      val: null,
      search: null
    }
  },
  created () {
    if (this.value) {
      getRunner(this.value).then((data) => {
        this.val = data
        this.updateItems(data.full_name)
      })
    } else {
      this.updateItems(null)
    }
  },
  watch: {
    search (val) {
      this.updateItems(val)
    }
  },
  methods: {
    change: function (i) {
      if (i) {
        this.$emit('input', i.id)
      } else {
        this.$emit('input', null)
      }
    },
    updateItems: function (text) {
      let params = {}
      if (text) {
        params['search'] = text
      }
      fetchRunners(params).then((data) => {
        this.items = data.results
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/runners/RunnerSelect.vue